module.exports = __webpack_public_path__ + "img/top_long_back.ef0daa0c.png";